import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import { connect } from 'react-redux';
import { videoPlay } from 'actions';

class Video extends Component {
	render() {
		const wrapperStyle = {
			position: 'relative',
			width: '100%',
			height: '0',
			paddingTop: '56.25%'
		}
		const playerStyle = {
			position: 'absolute',
			top: 0, left: 0, width: '100%', height: '100%',
		}
		const reactPlayerStyle = {
			backgroundColor: '#ffffff'
		}
		const playing = this.props.playing ? this.props.playing : (this.props.currentInst === this);
		return (
			<div className="player-wrapper" style={wrapperStyle}>
				<div style={playerStyle}>
					<ReactPlayer 
						url={this.props.url} 
						playing={playing} 
						controls={this.props.controls} 
						onPlay={ () => this.props.onPlay(this) }
						width="100%" height="100%" 
						style={ reactPlayerStyle }
					/>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		controls: true,
		currentInst: state.status.current_video
	}
}
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onPlay: (inst) => { dispatch( videoPlay(inst) ) }
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(Video);


// WEBPACK FOOTER //
// ./src/components/common/Video.jsx